export default function Go_Functions () {
  return (
    <div>
      <h1>Go_Functions </h1>
      <p>Functions</p>
    </div>
  );
}